import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import Mockups from '../components/Mockups';

const MockupsPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [mockupData, setMockupData] = useState({
      image_url: '',
      prompt: '',
      dalle_image: ''
    });
    const [selectedMockups, setSelectedMockups] = useState([]);
    const [mockupResponseData, setMockupResponseData] = useState(null);

    useEffect(() => {
        if (location.state) {
            setMockupData({
                image_url: location.state.image_url_to_mockups || '',
                prompt: location.state.prompt_to_mockups || '',
                dalle_image: location.state.dalle_image || ''
            });
        }
    }, [location.state]);

    const handleMockupsSelected = (selectedImages, responseData, finalList) => {
        setSelectedMockups(selectedImages);
        setMockupResponseData(responseData);
        // Navigate to PublishPage with necessary data
        navigate('/publish', { state: { selectedMockups, mockupResponseData, finalList } });
    };

    return (
        <Box sx={{ textAlign: 'left' }}>
            <h1>Mockups</h1>
            <Mockups mockupData={mockupData} onMockupsSelected={handleMockupsSelected} />
        </Box>
    );
};

export default MockupsPage;
